export const CountryCodes = {
  USA: { Code: 'US', Label: 'USA' },
  Canada: { Code: 'CA', Label: 'Canada' },
};
